import { Injectable, EventEmitter, Injector } from '@angular/core';
import { Location } from '../../dataModels/data-models';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

declare var google: any;

@Injectable()
export class MapHelper extends DiagnosedItem {

    private _map: any;
    private _markers: any[] = [];
    public prototype: any;

    public overlayObjectClicked: EventEmitter<any> = new EventEmitter<any>();

    public overlayObjects: any[] = [];

    constructor(protected injector: Injector) {
        super(injector);
    }

    setMap(map: any): void {
        this._map = map;
    }

    addMarker(location: Location): number {

        if (location) {

            //new google Marker
            var mapMarker = new google.maps.Marker();

            //set position
            mapMarker.setPosition({ lat: location.Latitude, lng: location.Longitude });

            //Add to map
            mapMarker.setMap(this._map);

            //Generate marker Id
            var markerId: number = this._markers.length;

            //push to markers list
            this._markers.push({ id: markerId, marker: mapMarker });

            //Return marker Id
            return markerId;
        }
    }

    removeMarker(markerId: number): void {

        //Find index of marker
        var index: number = this._markers.findIndex(x => x.id == markerId);

        //if exist
        if (index >= 0) {
            //Remove from marker
            this._markers[index].marker.setMap(null);
            //remove from list
            this._markers.splice(index, 1);
        }
    }

    //markerobjec as {id, element ,location{lat,lng}, metaData}
    addToOverlay(markerObjects: any[]) {

        if (!markerObjects || markerObjects.length == 0) {
            return;
        }

        this.overlayObjects = markerObjects;

        var self = this;

        this.prototype = new google.maps.OverlayView();

        this.prototype.setMap(this._map);

        this.prototype.onAdd = function () {

            var panes = this.getPanes();

            for (var obj of markerObjects) {

                //add to overlay
                panes.overlayMouseTarget.appendChild(obj.element);

                //set bounds
                obj.bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(obj.location.lat, obj.location.lng),
                    new google.maps.LatLng(obj.location.lat, obj.location.lng));
                // hide it when zoom < 13
                ///obj.element.hidden = self._map.zoom < 13;
                obj.element.hidden = false;

                //Register Click Event
                google.maps.event.addDomListener(obj.element, 'click', (event) => {

                    for (var object of markerObjects) {
                        if (event.currentTarget == object.element) {
                            self.overlayObjectClicked.emit(object);
                            return;
                        }
                    }

                });
            }
        }

        this.prototype.draw = function () {

            //get overlay projection
            var overlayProjection = this.getProjection();

            for (var obj of markerObjects) {

                //Get projection corners
                var sw = overlayProjection.fromLatLngToDivPixel(obj.bounds.getSouthWest());
                var ne = overlayProjection.fromLatLngToDivPixel(obj.bounds.getNorthEast());

                //set div location
                obj.element.style.left = (sw.x - 12) + 'px';
                obj.element.style.top = (ne.y - 12) + 'px';
            }
        }

        this.prototype.onRemove = function () {

            for (var obj of markerObjects) {
                obj.element.parentNode.removeChild(obj.element);
            }
        }
    }

    resetOverlay() {

        if (this.prototype) {
            this.prototype.setMap(null);
            this.overlayObjects = [];
        }
    }

    removeAllMarkers(): void {
        if (this._markers && this._markers.length > 0)
            //Remove all marker
            for (var i = 0; i < this._markers.length; i++) {
                //Remove from marker
                this._markers[i].marker.setMap(null);
            }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map-helper.service.ts